(() => {
  if (customElements.get('reviews-widget')) {
    return;
  }

  class ReviewsWidget extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    attachEvents() {
      this.prevButton?.addEventListener(
        'click',
        this.changePage.bind(this, 'prev'),
      );

      this.nextButton?.addEventListener(
        'click',
        this.changePage.bind(this, 'next'),
      );
    }

    init() {
      this.widget = this.querySelector('[data-widget]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      // Options for the observer (which mutations to observe)
      const config = {
        attributes: true,
        childList: true,
        subtree: true,
      };

      // Callback function to execute when mutations are observed
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            if (this.widget.querySelector('.R-PaginationControls')) {
              this.initPaginationArrows();

              this.observer.disconnect();

              break;
            }
          }
        }
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.widget, config);
    }

    initPaginationArrows() {
      const pagination = this.widget.querySelector('.R-PaginationControls');

      if (!pagination) {
        return;
      }

      const wrapper = document.createElement('div');

      wrapper.setAttribute('data-pagination-wrapper', '');

      pagination.parentNode.insertBefore(wrapper, pagination);

      if (this.prevButton) {
        wrapper.appendChild(this.prevButton);
      }

      wrapper.appendChild(pagination);

      if (this.nextButton) {
        wrapper.appendChild(this.nextButton);
      }
    }

    changePage(direction) {
      const pagination = this.widget.querySelector('.R-PaginationControls');

      if (!pagination) {
        return;
      }

      if (direction === 'next') {
        pagination.querySelector('.isActive')?.nextElementSibling?.click();

        return;
      }

      if (direction === 'prev') {
        pagination.querySelector('.isActive')?.previousElementSibling?.click();

        return;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('reviews-widget', ReviewsWidget);
})();
